import { render, staticRenderFns } from "./content.vue?vue&type=template&id=c0ee9148&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=c0ee9148&lang=scss&scoped=true"
import style1 from "./content.vue?vue&type=style&index=1&id=c0ee9148&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ee9148",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ee9148')) {
      api.createRecord('c0ee9148', component.options)
    } else {
      api.reload('c0ee9148', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=c0ee9148&scoped=true", function () {
      api.rerender('c0ee9148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/chat/widgets/content.vue"
export default component.exports